// extracted by mini-css-extract-plugin
export default {"input":"FileInput_input__XxxCz"};